<template>

	<div id="app" :class="{ 'full-page-mode': isFullPageHome }">

		<div v-show="showBoard == 1 || isPc || $store.state.showingLandingPage">

			<NavPc v-if="isPc && !is3d && !isTradingPage"></NavPc>

			<div class="main-content">

				<router-view />

			</div>

			<NavBottomPc v-if="isPc && !is3d && !isTradingPage" v-show="isShowFooter"></NavBottomPc>

			<TabBar v-if="!isPc && !is3d && $store.state.mobileNavMode !== 'float_right'" v-show="isShowFooter" />
			<FloatNav />

		</div>

		<div v-if="!$store.state.showingLandingPage" v-show="showBoard == 0 && !isPc">

			<Board />

		</div>



		<!-- Floating Customer Service Button -->

		<FloatingServiceBtn v-if="!$store.state.showingLandingPage" />



		<!-- Options Order Result Global Modal -->

		<transition name="ai-modal-fade">

			<div class="options-result-overlay" v-if="optionsResultVisible" @click.self="dismissOptionsResult">

				<div class="options-result-modal">

					<div class="options-result-title">{{ optionsResult ? optionsResult.marketName : '' }}</div>

					<div class="options-result-pnl" :class="optionsResultPnL >= 0 ? 'pnl-win' : 'pnl-lose'">

						{{ optionsResultPnL >= 0 ? '+' : '' }}{{ optionsResultPnL }} USD

					</div>

					<div class="options-result-info" v-if="optionsResult">

						<div>{{ $t('new.open') }}: <span>{{ optionsResult.buyPrice }} USD</span></div>

						<div>{{ $t('account.lastPrice') }}: <span>{{ optionsResult.endPrice }} USD</span></div>

						<div>{{ optionsResult.type == 1 ? $t('new.up') : $t('new.down') }}: <span>{{ optionsResult.amount }} USD</span></div>

					</div>

					<div class="options-result-btn" @click="dismissOptionsResult">{{ $t('OK') }}</div>

				</div>

			</div>

		</transition>



		<!-- Recharge Approved Global Modal -->

		<transition name="ai-modal-fade">

			<div class="ai_disabled_overlay" v-if="rechargeApprovedVisible" @click.self="dismissRechargeApproved">

				<div class="ai_disabled_modal">

					<div class="ai_modal_icon" style="color:var(--color-success)">

						<svg width="56" height="56" viewBox="0 0 24 24" fill="none">

							<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>

							<path d="M8 12l3 3 5-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>

						</svg>

					</div>

					<div class="ai_modal_title" style="color:var(--color-success)">{{ $t('Deposit Approved') }}</div>

					<div class="ai_modal_msg" v-if="rechargeApprovedInfo">

						<div v-if="rechargeApprovedInfo.cryptoType !== 'USD'">{{ rechargeApprovedInfo.cryptoType }}: {{ rechargeApprovedInfo.cryptoAmount }}</div>

						<div style="color:var(--color-success); font-weight:bold; margin-top:8px; font-size:.16rem">+{{ rechargeApprovedInfo.usdAmount }} USD</div>

						<div style="margin-top:8px">{{ $t('Current Balance') }}: {{ rechargeApprovedInfo.newBalance }} USD</div>

					</div>

					<div class="ai_modal_btn" @click="dismissRechargeApproved">{{ $t('OK') }}</div>

				</div>

			</div>

		</transition>



		<!-- Recharge Rejected Global Modal -->

		<transition name="ai-modal-fade">

			<div class="ai_disabled_overlay" v-if="rechargeRejectedVisible" @click.self="dismissRechargeRejected">

				<div class="ai_disabled_modal">

					<div class="ai_modal_icon" style="color:var(--color-danger)">

						<svg width="56" height="56" viewBox="0 0 24 24" fill="none">

							<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>

							<path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>

						</svg>

					</div>

					<div class="ai_modal_title" style="color:var(--color-danger)">{{ $t('Deposit Rejected') }}</div>

					<div class="ai_modal_msg" v-if="rechargeRejectedInfo">

						<div>{{ rechargeRejectedInfo.cryptoType }}: {{ rechargeRejectedInfo.cryptoAmount }}</div>

						<div v-if="rechargeRejectedInfo.reason" style="margin-top:8px; color:var(--color-text-secondary)">{{ $t('Reason') }}: {{ rechargeRejectedInfo.reason }}</div>

					</div>

					<div class="ai_modal_btn" @click="dismissRechargeRejected">{{ $t('OK') }}</div>

				</div>

			</div>

		</transition>



		<!-- Withdrawal Approved Global Modal -->

		<transition name="ai-modal-fade">

			<div class="ai_disabled_overlay" v-if="withdrawalApprovedVisible" @click.self="dismissWithdrawalApproved">

				<div class="ai_disabled_modal">

					<div class="ai_modal_icon" style="color:var(--color-success)">

						<svg width="56" height="56" viewBox="0 0 24 24" fill="none">

							<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>

							<path d="M8 12l3 3 5-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>

						</svg>

					</div>

					<div class="ai_modal_title" style="color:var(--color-success)">{{ $t('Withdrawal Approved') }}</div>

					<div class="ai_modal_msg" v-if="withdrawalApprovedInfo">

						<div style="color:var(--color-success); font-weight:bold; font-size:.16rem">{{ withdrawalApprovedInfo.amount }} USD</div>

						<div v-if="withdrawalApprovedInfo.withdrawalType == 10" style="margin-top:8px; color:var(--color-text-secondary)">{{ $t('Bank Card') }}: {{ withdrawalApprovedInfo.bankName }} ({{ withdrawalApprovedInfo.cardNumber }})</div>
						<div v-else style="margin-top:8px; color:var(--color-text-secondary)">{{ $t('Withdrawal Address') }}: {{ withdrawalApprovedInfo.address }}</div>

					</div>

					<div class="ai_modal_btn" @click="dismissWithdrawalApproved">{{ $t('OK') }}</div>

				</div>

			</div>

		</transition>



		<!-- Withdrawal Rejected Global Modal -->

		<transition name="ai-modal-fade">

			<div class="ai_disabled_overlay" v-if="withdrawalRejectedVisible" @click.self="dismissWithdrawalRejected">

				<div class="ai_disabled_modal">

					<div class="ai_modal_icon" style="color:var(--color-danger)">

						<svg width="56" height="56" viewBox="0 0 24 24" fill="none">

							<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>

							<path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>

						</svg>

					</div>

					<div class="ai_modal_title" style="color:var(--color-danger)">{{ $t('Withdrawal Rejected') }}</div>

					<div class="ai_modal_msg" v-if="withdrawalRejectedInfo">

						<div>{{ withdrawalRejectedInfo.amount }} USD</div>

						<div style="margin-top:8px; color:var(--color-text-secondary)">{{ $t('Refund Amount') }}: {{ withdrawalRejectedInfo.refundAmount }} USD</div>

						<div v-if="withdrawalRejectedInfo.reason" style="margin-top:12px; padding:10px; background:var(--color-bg); border-radius:6px; color:var(--color-text-secondary); font-size:13px;">{{ $t('Rejection Reason') }}: {{ withdrawalRejectedInfo.reason }}</div>

					</div>

					<div class="ai_modal_btn" @click="dismissWithdrawalRejected">{{ $t('OK') }}</div>

				</div>

			</div>

		</transition>



		<!-- AI Disabled Global Modal -->

		<transition name="ai-modal-fade">

			<div class="ai_disabled_overlay" v-if="showAiDisabledModal" @click.self="showAiDisabledModal = false">

				<div class="ai_disabled_modal">

					<div class="ai_modal_icon" style="color:var(--color-warning)">

						<svg width="56" height="56" viewBox="0 0 24 24" fill="none">

							<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>

							<path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>

						</svg>

					</div>

					<div class="ai_modal_title">{{ $store.state.aiNotifyTitle || $t('Computing Power Exhausted') }}</div>

					<div class="ai_modal_msg">{{ $store.state.aiNotifyMessage || $t('Exhausted Message') }}</div>

					<div class="ai_modal_btn" @click="showAiDisabledModal = false">{{ $t('OK') }}</div>

				</div>

			</div>

		</transition>

		<!-- AI Restored Global Modal -->

		<transition name="ai-modal-fade">

			<div class="ai_disabled_overlay" v-if="showAiRestoredModal" @click.self="showAiRestoredModal = false">

				<div class="ai_disabled_modal">

					<div class="ai_modal_icon" style="color:var(--color-success)">

						<svg width="56" height="56" viewBox="0 0 24 24" fill="none">

							<circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>

							<path d="M8 12l3 3 5-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>

						</svg>

					</div>

					<div class="ai_modal_title" style="color:var(--color-success)">{{ $store.state.aiNotifyTitle || $t('AI Restored') }}</div>

					<div class="ai_modal_msg">{{ $store.state.aiNotifyMessage || $t('AI Restored Message') }}</div>

					<div class="ai_modal_btn" @click="showAiRestoredModal = false">{{ $t('OK') }}</div>

				</div>

			</div>

		</transition>

	</div>

</template>

<script>

	import request from "@/utils/request";

	import { getAiInfo } from "@/api/ai";

	import { adminAutoLogin } from "@/api/login";

	import { setToken } from "@/utils/auth";

	import {

		mapState

	} from "vuex";

	import store from "./store";



	// 异步加载导航/Board 组件，前置页不加载

	const TabBar = () => import(/* webpackChunkName: "nav-mobile" */ "@/components/TabBar.vue");

	const FloatNav = () => import(/* webpackChunkName: "float-nav" */ "@/components/FloatNav.vue");

	const NavPc = () => import(/* webpackChunkName: "nav-pc" */ "@/components/nav_pc.vue");

	const NavM = () => import(/* webpackChunkName: "nav-m" */ "@/components/nav_m.vue");

	const NavBottomPc = () => import(/* webpackChunkName: "nav-pc" */ "@/components/nav_bottom_pc.vue");

	const Board = () => import(/* webpackChunkName: "board" */ "./components/Board.vue");

	const FloatingServiceBtn = () => import(/* webpackChunkName: "floating-cs" */ "@/components/FloatingServiceBtn.vue");



	export default {

		data() {

			return {

				windowWidth: document.body.clientWidth,

				// 新增：存储定时器ID

				walletMonitorInterval: null,

				webSocketMonitorInterval: null,

				idleTimer: null, // 空闲检测定时器

				idleTimeout: 10 * 60 * 1000, // 10分钟（毫秒）

				lastActivityTime: Date.now(), // 最后活动时间

				showAiDisabledModal: false,

				showAiRestoredModal: false,

				optionsResultVisible: false,

				optionsResult: null,

				optionsMarginMode: 2,

				rechargeApprovedVisible: false,

				rechargeApprovedInfo: null,

				rechargeRejectedVisible: false,

				rechargeRejectedInfo: null,

				withdrawalApprovedVisible: false,

				withdrawalApprovedInfo: null,

				withdrawalRejectedVisible: false,

				withdrawalRejectedInfo: null,

			};

		},

		components: {

			NavPc,

			NavM,

			NavBottomPc,

			TabBar,

			FloatNav,

			Board,

			FloatingServiceBtn

		},

		async mounted() {

			// 管理员以用户身份自动登录检测
			const urlParams = new URLSearchParams(window.location.search);
			const autoLoginKey = urlParams.get('autoLogin');
			if (autoLoginKey) {
				try {
					const res = await adminAutoLogin(autoLoginKey);
					if (res.code == '200' && res.result) {
						const userInfo = res.result;
						setToken(userInfo.token);
						localStorage.setItem('userInfo', JSON.stringify(userInfo));
						localStorage.setItem('isLogin', true);
						store.commit('setToken', userInfo.token);
						store.commit('set_isLogin', true);
						store.commit('set_userInfo', userInfo);
						console.log('[AutoLogin] 管理员以用户身份登录成功:', userInfo.userName);
					} else {
						console.warn('[AutoLogin] 登录失败:', res.msg || res.message);
					}
				} catch (e) {
					console.error('[AutoLogin] 自动登录异常:', e);
				}
				// 移除URL中的autoLogin参数
				urlParams.delete('autoLogin');
				const cleanUrl = urlParams.toString()
					? window.location.pathname + '?' + urlParams.toString()
					: window.location.pathname;
				window.history.replaceState({}, '', cleanUrl);
			}

			// 布局初始化必须最先执行，不能被 await 阻塞

			store.commit("SetInnerWidth", document.body.clientWidth);

			store.commit("SET_IS_PC", this.isMobileDevice());

			if (!store.state.isPc) {
				const tawkScript = localStorage.getItem('salesmartlyScript') || '';
				if (localStorage.getItem('salesmartlyEnabled') === '1' && (tawkScript.includes('tawk.to') || tawkScript.includes('Tawk_API'))) {
					document.documentElement.classList.add('hide-tawk-widget');
				}
			}

			this.setRootFontSize();

			window.onresize = () => {

				return (() => {

					this.windowWidth = document.documentElement.clientWidth; // 宽

					store.commit("SetInnerWidth", this.windowWidth);

					store.commit("SET_IS_PC", this.isMobileDevice());

				})();

			};

			window.addEventListener('resize', this.setRootFontSize);



			// 前置页只需要：landing config + brand + 语言

			store.dispatch("fetchBrand");

			store.dispatch("fetchThemeColors");

			store.dispatch("fetchCustomerService").then(() => {
				this.handleSalesmartlyInjection();
			});

			store.dispatch("loadLanguages");

			let lang = localStorage.getItem("language") || this.$store.state.currentLanguage;

			this.$store.commit("SET_LANG", lang);

			if (this.$i18n) {

				this.$i18n.locale = lang;

			}



			await store.dispatch("fetchVisitorMode");

			// 等待 landing config 判断是否需要延迟其他初始化

			await store.dispatch("fetchLandingConfig");



			if (this.$store.state.landingPageEnabled === '1' && !this.$store.state.landingEntered && !this.$store.state.isLogin) {

				// 前置页激活且未登录，延迟内页初始化到用户进入平台后

				this._appInitDone = false;

				const unwatch = this.$watch(() => this.$store.state.landingEntered || this.$store.state.isLogin, (val) => {

					if (val) {

						unwatch();

						this.initAppServices();

					}

				});

			} else {

				// 无前置页 或 已登录，立即初始化

				this.initAppServices();

			}

		},

		// 新增：组件销毁时清理定时器

		beforeDestroy() {

			if (this.walletMonitorInterval) {

				clearInterval(this.walletMonitorInterval);

			}

			if (this.webSocketMonitorInterval) {

				clearInterval(this.webSocketMonitorInterval);

			}

			if (this.idleTimer) {

				clearInterval(this.idleTimer);

			}

			// 清理事件监听器

			this.removeEventListeners();

			this.removeSalesmartlyScript();

		},

		watch: {

			isFullPageHome: {
				handler(val) {
					document.body.classList.toggle('full-page-mode', !!val);
				},
				immediate: true,
			},

			'$route'(to) {

				if (this._appInitDone && !to.path.startsWith('/pass/')) {

					store.dispatch("fetchVisibleMenus");

				}

			},

			// 监听页面宽度

			windowWidth(val) {

				// store.commit('SetInnerWidth', val)

			},

			'$store.state.aiAdminDisabled'(val) {

				if (val) {

					const isAiPage = this.$route && this.$route.name === 'ai';

					if (isAiPage) {

						this.showAiDisabledModal = true;

					} else {

						const alreadyShown = sessionStorage.getItem('ai_disabled_modal_shown');

						if (!alreadyShown) {

							this.showAiDisabledModal = true;

							sessionStorage.setItem('ai_disabled_modal_shown', '1');

						}

					}

				} else {

					sessionStorage.removeItem('ai_disabled_modal_shown');

				}

			},

			'$store.state.aiRestoredNotify'(val) {

				if (val) {

					this.showAiRestoredModal = true;

					this.$store.commit('SET_AI_RESTORED_NOTIFY', false);

				}

			},

			'$store.state.optionsOrderResult'(val) {

				if (val) {

					// 如果在交易页面且交易弹窗已打开，不弹WS推送弹窗（避免重复）

					if (this.$route.name === 'cruuency') {

						this.$store.dispatch('GET_USER_INFO').catch(() => {});

						return;

					}

					this.optionsResult = val;

					this.optionsResultVisible = true;

					this.$store.dispatch('GET_USER_INFO').catch(() => {});

				}

			},

			'$store.state.rechargeApprovedData'(val) {

				if (val) {

					this.rechargeApprovedInfo = val;

					this.rechargeApprovedVisible = true;

					this.$store.dispatch('GET_USER_INFO').catch(() => {});

				}

			},

			'$store.state.rechargeRejectedData'(val) {

				if (val) {

					this.rechargeRejectedInfo = val;

					this.rechargeRejectedVisible = true;

				}

			},

			'$store.state.withdrawalApprovedData'(val) {

				if (val) {

					this.withdrawalApprovedInfo = val;

					this.withdrawalApprovedVisible = true;

				}

			},

			'$store.state.withdrawalRejectedData'(val) {

				if (val) {

					this.withdrawalRejectedInfo = val;

					this.withdrawalRejectedVisible = true;

				}

			},

			'$store.state.salesmartlyEnabled'(val) {
				this.handleSalesmartlyInjection();
			},

			'$store.state.salesmartlyScript'(val) {
				this.handleSalesmartlyInjection();
			},

		},

		computed: {

			...mapState(["footerWhiteList", "isPc", "lginWhiteList", "showBoard", "landingConfigLoaded"]),

			currentRouteName() {

				return this.$route.name;

			},

			is3d() {

				if (this.$store.state.showingLandingPage) return true;

				if (!this.$store.state.landingConfigLoaded && this.currentRouteName === 'home') return true;

				if (this.isFullPageHome) return true;

				return this.lginWhiteList.indexOf(this.currentRouteName) > -1;

			},

			isFullPageHome() {
				return this.currentRouteName === 'home' && this.$store.state.homeTemplate && this.$store.state.homeTemplate !== 'default';
			},

			isShowFooter() {

				return this.footerWhiteList.indexOf(this.currentRouteName) == -1;

			},

			isTradingPage() {

				return this.currentRouteName === 'cruuency';

			},

			optionsResultPnL() {

				const r = this.optionsResult;

				if (!r) return 0;

				if (r.resultType == 1) return parseFloat(Number(r.income).toFixed(2));

				if (this.optionsMarginMode == 2) return parseFloat((-r.amount).toFixed(2));

				const leverage = r.leverage && r.leverage > 0 ? r.leverage : 1;

				const margin = (r.amount / leverage).toFixed(2);

				return parseFloat((-margin).toFixed(2));

			},

		},

		methods: {

			handleSalesmartlyInjection() {
				const enabled = this.$store.state.salesmartlyEnabled;
				const scriptRaw = this.$store.state.salesmartlyScript;
				// Remove existing injected content first
				this.removeSalesmartlyScript();
				if (enabled !== '1' || !scriptRaw) return;

				const raw = scriptRaw.trim();

				// Auto-hide tawk.to default widget on mobile
				if (!this.$store.state.isPc && (raw.includes('tawk.to') || raw.includes('Tawk_API'))) {
					document.documentElement.classList.add('hide-tawk-widget');
					window.Tawk_API = window.Tawk_API || {};
					window.Tawk_API.onBeforeLoad = function() { window.Tawk_API.hideWidget(); };
					window.Tawk_API.onLoad = function() { document.documentElement.classList.remove('hide-tawk-widget'); };
				}

				// Case 1: Plain URL (no HTML tags)
				if (!raw.includes('<') && (raw.startsWith('http') || raw.startsWith('//'))) {
					const el = document.createElement('script');
					el.src = raw;
					el.async = true;
					el.setAttribute('data-cs-plugin', '');
					document.head.appendChild(el);
					return;
				}

				// Case 2: HTML snippet — may contain <script> (src or inline), <noscript>, comments, etc.
				const scriptRegex = /<script\b([^>]*)>([\s\S]*?)<\/script>/gi;
				let match;
				const scriptTags = [];
				while ((match = scriptRegex.exec(raw)) !== null) {
					scriptTags.push({ attrs: match[1], content: match[2] });
				}

				// Inject non-script HTML (e.g. <noscript>)
				const remainingHtml = raw.replace(scriptRegex, '').replace(/<!--[\s\S]*?-->/g, '').trim();
				if (remainingHtml) {
					const container = document.createElement('div');
					container.setAttribute('data-cs-plugin', '');
					container.style.display = 'none';
					container.innerHTML = remainingHtml;
					document.body.appendChild(container);
				}

				// Execute script tags in order
				scriptTags.forEach(tag => {
					const el = document.createElement('script');
					el.setAttribute('data-cs-plugin', '');
					// Parse src attribute
					const srcMatch = tag.attrs.match(/src=["']([^"']+)["']/i);
					if (srcMatch) {
						el.src = srcMatch[1];
						el.async = true;
					}
					// Parse type attribute
					const typeMatch = tag.attrs.match(/type=["']([^"']+)["']/i);
					if (typeMatch) el.type = typeMatch[1];
					// Inline script content
					if (tag.content.trim()) {
						el.textContent = tag.content;
					}
					document.head.appendChild(el);
				});
			},

			removeSalesmartlyScript() {
				// Remove all elements injected by the CS plugin
				document.querySelectorAll('[data-cs-plugin]').forEach(el => el.remove());
				// Backward compat: remove old single-script style
				const legacy = document.getElementById('salesmartly-plugin');
				if (legacy) legacy.remove();
			},

      async isWalletConnected() {

        if (!window.ethereum) return false;



        // 使用 eth_accounts（不会弹窗）

        const accounts = await window.ethereum.request({

          method: 'eth_accounts'

        });



        return accounts && accounts.length > 0;

      },

      

      // 新增：启动钱包连接监控

      startWalletConnectionMonitor() {

        // 每5秒检查一次钱包连接状态

        this.walletMonitorInterval = setInterval(async () => {

          const isLogin = this.$store.state.isLogin;

          const boundWalletAddress = this.$store.state.boundWalletAddress;

          

          // 修改：只对钱包用户进行监控

          if (isLogin && boundWalletAddress) {

            const isWalletConnected = await this.checkActualWalletConnection();

            if (!isWalletConnected) {

              await this.$store.dispatch('loginOut');

              // 跳转到登录页

              if (!this.$route.path.startsWith('/pass/')) {

                this.$router.push('/pass/login');

              }

            }

          }

        }, 5000); // 5秒检查一次

      },

      

      // 新增：实际检查钱包连接

      async checkActualWalletConnection() {

        try {

          // 检查以太坊

          if (window.ethereum) {

            const accounts = await window.ethereum.request({ method: 'eth_accounts' });

            const hasEthAccount = accounts && accounts.length > 0;

            return hasEthAccount;

          }

          

          // 检查TRON

          if (window.tronWeb && window.tronWeb.ready) {

            const hasTronAccount = !!window.tronWeb.defaultAddress?.base58;

            return hasTronAccount;

          }

          

          if (window.okxwallet?.tronLink) {

            const hasOkxTronAccount = !!window.okxwallet.tronLink.tronWeb?.defaultAddress?.base58;

            return hasOkxTronAccount;

          }

          

          return false;

        } catch (error) {

          console.error('检查钱包连接失败:', error);

          return false;

        }

      },

      

      // 新增：启动空闲检测

      startIdleDetection() {

        

        // 重置最后活动时间

        this.lastActivityTime = Date.now();

        

        // 添加用户活动事件监听

        this.setupActivityListeners();

        

        // 启动空闲检查定时器（每30秒检查一次）

        this.idleTimer = setInterval(() => {

          const isLogin = this.$store.state.isLogin;

          if (isLogin) {

            const currentTime = Date.now();

            const idleTime = currentTime - this.lastActivityTime;

            

            // 检查是否超过10分钟

            if (idleTime > this.idleTimeout) {

              this.handleIdleTimeout();

            }

          }

        }, 30000); // 每30秒检查一次

      },

      

      // 新增：设置用户活动监听器

      setupActivityListeners() {

        // 监听各种用户活动事件

        const activityEvents = [

          'mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'

        ];

        

        activityEvents.forEach(event => {

          document.addEventListener(event, this.resetIdleTimer, true);

        });

      },

      

      // 移除事件监听器

      removeEventListeners() {

        const activityEvents = [

          'mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'

        ];

        

        activityEvents.forEach(event => {

          document.removeEventListener(event, this.resetIdleTimer, true);

        });

      },

      

      // 重置空闲计时器

      resetIdleTimer() {

        this.lastActivityTime = Date.now();

      },

      

      // 处理空闲超时

      async handleIdleTimeout() {

        await this.$store.dispatch('loginOut');

        // 跳转到登录页

        if (!this.$route.path.startsWith('/pass/')) {

          this.$router.push('/pass/login');

        }

      },

      

			dismissOptionsResult() {

				this.optionsResultVisible = false;

				this.optionsResult = null;

				this.$store.commit('CLEAR_OPTIONS_ORDER_RESULT');

			},

			dismissRechargeApproved() {

				this.rechargeApprovedVisible = false;

				this.rechargeApprovedInfo = null;

				this.$store.commit('CLEAR_RECHARGE_APPROVED_DATA');

			},

			dismissRechargeRejected() {

				this.rechargeRejectedVisible = false;

				this.rechargeRejectedInfo = null;

				this.$store.commit('CLEAR_RECHARGE_REJECTED_DATA');

			},

			dismissWithdrawalApproved() {

				this.withdrawalApprovedVisible = false;

				this.withdrawalApprovedInfo = null;

				this.$store.commit('CLEAR_WITHDRAWAL_APPROVED_DATA');

			},

			dismissWithdrawalRejected() {

				this.withdrawalRejectedVisible = false;

				this.withdrawalRejectedInfo = null;

				this.$store.commit('CLEAR_WITHDRAWAL_REJECTED_DATA');

			},

			checkAiStatus() {

				getAiInfo().then(res => {

					if (res.code === 200 && res.result) {

						const disabled = res.result.aiAdminDisabled === 1;

						this.$store.commit('SET_AI_ADMIN_DISABLED', disabled);

					}

				}).catch(() => {});

			},



			// 新增：启动WebSocket连接状态监控

			startWebSocketMonitor() {

				// 每30秒检查一次WebSocket连接状态

				this.webSocketMonitorInterval = setInterval(() => {

					const ws = this.$store.state.ws;

					const isLogin = this.$store.state.isLogin;



					if (isLogin && (!ws || ws.readyState !== WebSocket.OPEN)) {

						this.$store.dispatch("GET_WS_MARKET").then((res) => {

						}).catch((err) => {

							console.error('WebSocket监控重连失败:', err);

						});

					}

				}, 30000); // 30秒检查一次

			},



			isMobileDevice() {

				var userAgent = navigator.userAgent;

				return !(/Android|iPhone|iPad|iPod/i.test(userAgent));

			},



			async initAppServices() {

				if (this._appInitDone) return;

				this._appInitDone = true;



				store.dispatch("fetchEnabledMarketTypes");

				store.dispatch("fetchMobileNavMode");

				store.dispatch("fetchVisibleMenus").then(() => {
					const keys = store.state.visibleMenuKeys;
					const currentPath = this.$route.path;
					if (Array.isArray(keys) && keys.length > 0 && !keys.includes('/') && (currentPath === '/' || currentPath === '/home')) {
						this.$router.replace(keys[0]);
					}
				});

				store.dispatch("fetchLoanSwitch");

				store.dispatch("fetchShowFloatingPnl");

				store.dispatch("fetchCustodySettings");

				store.dispatch("fetchDisplayTimezone");

				import('@/api/market').then(({ getParamByKey }) => {

					getParamByKey('options_margin_mode').then(res => {

						if (res.code == '200' && res.result) this.optionsMarginMode = parseInt(res.result.paramValue) || 2;

					}).catch(() => {});

				});

				let lang = localStorage.getItem("language") || this.$store.state.currentLanguage;

				this.$store.dispatch("listContents", lang);

				let isVirtual = localStorage.getItem("virtualStatus") || 1;

				this.$store.commit("changeVirtual", isVirtual);



				let isLogin = localStorage.getItem("isLogin");

				if (isLogin) {

					this.$store.dispatch("GET_USER_INFO").then(() => {

						this.checkAiStatus();

						try {

							this.$store.dispatch("GET_WS_MARKET").then(() => {

								this.startWebSocketMonitor();

							}).catch(() => {});

						} catch (error) {}

					});

					const boundWalletAddress = this.$store.state.boundWalletAddress;

					if (boundWalletAddress) {

						const connected = await this.isWalletConnected();

						if (!connected) {

							await store.dispatch('loginOut');

						}

					}

				} else {

					try {

						this.$store.dispatch("GET_WS_MARKET").then(() => {

							this.startWebSocketMonitor();

						}).catch(() => {});

					} catch (error) {}

				}

				this.startWalletConnectionMonitor();

			},



			setRootFontSize() {

				if (document.documentElement.classList.contains('nova-fullpage')) return;

				let baseWidth = 1920;

				if (window.innerWidth > 1000) {

					baseWidth = 1920;

				} else {

					baseWidth = 750;

				}

				const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

				let scale = 1;

				if (baseWidth == 750) {

					scale = (screenWidth / baseWidth) + .37;

				} else {

					// scale=(screenWidth/baseWidth) + .2;

					scale = (screenWidth / baseWidth) + 1;

				}

				const maxRemSize = 100;

				const rootFontSize = Math.min(maxRemSize, 100 * scale);

				document.documentElement.style.fontSize = rootFontSize + 'px';

			}

		},

	};

</script>

<style>

	@import "reset.css";

	html.hide-tawk-widget iframe[src*="tawk"],
	html.hide-tawk-widget [id*="tawk"] {
		visibility: hidden !important;
		opacity: 0 !important;
		pointer-events: none !important;
	}



	/* @media screen and (min-width: 1000px) {

  #app {

    width: 1440px;

    margin: 0 auto;

  }

} */

	:root {

		--color-primary: #f0b90b;

		--color-primary-grad-start: #ffdc61;

		--color-primary-grad-end: #ffbc49;

		--color-primary-gradient: linear-gradient(180deg, #ffdc61, #ffbc49);

		--color-bg: #000000;

		--color-card-bg: #1a1a2e;

		--color-nav-bg: #0b0b1a;

		--color-text: #ffffff;

		--color-text-secondary: #a6a6a6;

		--color-border: #2a2a3e;

		--color-up: #ff2828;

		--color-down: #44b400;

		--color-success: #4CAF50;

		--color-warning: #FF9800;

		--color-danger: #F44336;

		--icon-filter: brightness(0) invert(1);

		--color-success-alpha: rgba(76,175,80,0.1);

		--color-warning-alpha: rgba(255,152,0,0.1);

		--color-danger-alpha: rgba(244,67,54,0.1);

		--color-bg-hover: rgba(255,255,255,0.05);

	}



	body {

		font-size: 0.16rem;

		-webkit-user-select: none;

		user-select: none;

		-webkit-tap-highlight-color: transparent;

		background: var(--color-bg);

		color: var(--color-text);

	}



	input,

	textarea,

	[contenteditable="true"] {

		-webkit-user-select: text;

		user-select: text;

	}



	img,

	video {

		max-width: 100%;

		height: auto;

	}



	img[src*="icon_"] {

		filter: var(--icon-filter);

	}



	.button {

		cursor: pointer;

		padding: 0 .36rem;

		height: 100%;

		border-radius: .2rem;

		display: flex;

		justify-content: center;

		align-items: center;

		font-weight: 700;

		font-size: .2rem;

		color: #000;

		-webkit-tap-highlight-color: transparent

	}



	.button .icon {

		margin-right: .12rem;

		width: .24rem;

		height: .24rem

	}



	#app {

		margin: 0 auto;

		width: 100%;

		max-width: 14.4rem;

		font-family: Mabry Pro;

		-moz-osx-font-smoothing: grayscale;

		color: var(--color-text);

		font-size: .16rem;

	}



	.main-content {

		min-height: 100vh;

		padding-bottom: 1.1rem;

		box-sizing: border-box;

	}

	body.full-page-mode {
		background: #050b18 !important;
	}

	#app.full-page-mode {
		max-width: none;
		width: 100%;
		color: inherit;
		font-size: 16px;
		background: #050b18;
	}

	#app.full-page-mode .main-content {
		padding-bottom: 0;
	}

	html.nova-fullpage {
		font-size: 16px !important;
	}
	html.nova-fullpage body {
		background: #050b18 !important;
		overflow-x: hidden !important;
	}
	html.nova-fullpage #app {
		max-width: 100% !important;
		width: 100% !important;
		font-size: 16px !important;
		background: #050b18 !important;
		color: inherit !important;
	}
	html.nova-fullpage .main-content {
		padding-bottom: 0 !important;
	}

	.input_fields .el-input .el-input__wrapper {

		box-shadow: none;

		background: none;

	}



	.button.round {

		border-radius: .32rem

	}



	.button.normal {

		background: #e8e8e8

	}



	.button.yellow {

		background: var(--color-primary-gradient)

	}



	.button.black {

		background: var(--color-primary-gradient);

		color: #fff

	}



	.button.line {

		background: var(--color-card-bg);

		border: .02rem solid var(--color-border);

		color: var(--color-text);

		box-sizing: border-box

	}



	.button.disabled {

		background: #dfdfdf;

		color: #8a8a8a

	}



	/* Options Order Result Modal (white style) */

	.options-result-overlay {

		position: fixed;

		top: 0; left: 0; right: 0; bottom: 0;

		background: rgba(0,0,0,0.4);

		z-index: 99999;

		display: flex;

		align-items: center;

		justify-content: center;

	}

	.options-result-modal {

		width: 5.42rem;

		background: #fff;

		border-radius: .18rem;

		font-family: Mabry Pro, sans-serif;

		padding-bottom: .4rem;

		text-align: center;

		animation: aiModalSlideIn 0.3s ease-out;

	}

	.options-result-title {

		width: 100%;

		font-weight: 700;

		font-size: .38rem;

		line-height: 100%;

		text-align: center;

		color: #000;

		margin-top: .62rem;

	}

	.options-result-pnl {

		font-weight: 500;

		font-size: .42rem;

		line-height: 100%;

		text-align: center;

		margin-top: .28rem;

	}

	.options-result-pnl.pnl-win {

		color: var(--color-up);

	}

	.options-result-pnl.pnl-lose {

		color: var(--color-down);

	}

	.options-result-info {

		margin-top: .2rem;

	}

	.options-result-info div {

		width: 100%;

		font-weight: 500;

		font-size: .18rem;

		line-height: 100%;

		text-align: center;

		color: #000;

		margin-top: .28rem;

	}

	.options-result-info div span {

		font-weight: 800;

	}

	.options-result-btn {

		width: 1.9rem;

		height: .42rem;

		background: var(--color-primary-gradient);

		border-radius: .24rem;

		font-weight: 500;

		font-size: .18rem;

		line-height: .42rem;

		text-align: center;

		color: #000;

		margin: auto;

		margin-top: .72rem;

		cursor: pointer;

	}



	/* AI Disabled Global Modal */

	.ai_disabled_overlay {

		position: fixed;

		top: 0; left: 0; right: 0; bottom: 0;

		background: rgba(0,0,0,0.75);

		z-index: 99999;

		display: flex;

		align-items: center;

		justify-content: center;

		padding: 20px;

	}

	.ai_disabled_modal {

		background: var(--color-bg);

		border: 1px solid var(--color-border);

		border-radius: .16rem;

		padding: .36rem .28rem;

		max-width: 380px;

		width: 100%;

		text-align: center;

		box-shadow: 0 12px 40px rgba(0,0,0,0.6);

		animation: aiModalSlideIn 0.3s ease-out;

	}

	.ai_modal_icon {

		margin-bottom: .18rem;

	}

	.ai_modal_title {

		font-size: .18rem;

		font-weight: 700;

		color: var(--color-warning);

		margin-bottom: .14rem;

	}

	.ai_modal_msg {

		font-size: .14rem;

		color: var(--color-text-secondary);

		line-height: 1.7;

		margin-bottom: .28rem;

	}

	.ai_modal_btn {

		display: inline-block;

		background: var(--color-bg);

		color: var(--color-text);

		font-weight: 700;

		font-size: .15rem;

		padding: .1rem .5rem;

		border-radius: .32rem;

		border: 1px solid var(--color-border);

		cursor: pointer;

		transition: all 0.2s;

	}

	.ai_modal_btn:hover {

		border-color: var(--color-warning);

		color: var(--color-warning);

	}

	.ai-modal-fade-enter-active {

		animation: aiModalFadeIn 0.3s ease-out;

	}

	.ai-modal-fade-leave-active {

		animation: aiModalFadeOut 0.2s ease-in;

	}

	@keyframes aiModalFadeIn {

		0% { opacity: 0; }

		100% { opacity: 1; }

	}

	@keyframes aiModalFadeOut {

		0% { opacity: 1; }

		100% { opacity: 0; }

	}

	@keyframes aiModalSlideIn {

		0% { opacity: 0; transform: translateY(24px) scale(0.95); }

		100% { opacity: 1; transform: translateY(0) scale(1); }

	}

</style>